import Moment from 'moment';
import {setOffersFields} from './persistOfferDetails';

export const PAST_POLICY_START_DATE = 'PAST_POLICY_START_DATE';

export const isPastPolicyStartDateResponse = (resp) =>
  resp?.success === false && resp?.exception?.errorCode === PAST_POLICY_START_DATE;

// realigns storage with the date the server is willing to accept, so the user is not
// bounced back into the same rejected date
export const applyServerStartDate = (newStartDate) => {
  if (!newStartDate) {
    return;
  }
  const start = Moment(newStartDate, 'YYYY-MM-DD');
  if (!start.isValid()) {
    return;
  }
  setOffersFields({
    endDate: start.clone().add(1, 'year').subtract(1, 'month').endOf('month')
      .format('DD/MM/YYYY'),
    startDate: start.format('DD/MM/YYYY'),
  });
};

// the confirmation screen renders from sessionStorage, so realign it with the dates
// the payment was actually made with
export const alignStoredPolicyDates = ({policyStartDate, policyEndDate} = {}) => {
  const dates = {};
  if (policyStartDate) {
    dates.startDate = policyStartDate;
  }
  if (policyEndDate) {
    dates.endDate = policyEndDate;
  }
  if (Object.keys(dates).length > 0) {
    setOffersFields(dates);
  }
};
